import InterceptorManager from './lib/Interceptor-manage'
import { commandOptions, PromiseArr, IMedxResponse } from './interfaces/interfaces'
declare var CefSharp: any
declare var IMedxAsync: any
// declare var window: any

class IcsChromelyClient {
  // private _baseCommandUrl: string = 'http://command.com/'
  private _baseAjaxUrl: string = 'http://icreate.com/'
  public isChromely = !!(window as any)['CefSharp']

  headers: { [key: string]: string }
  fetch: any
  public interceptors: {
    request: InterceptorManager<IcsChromelyClient>
    response: InterceptorManager<IMedxResponse<any>>
  }
  constructor({ headers = {}, fetch }: { headers?: { [key: string]: string }; fetch?: any } = {}) {
    this.headers = { ...headers }
    this.fetch = fetch || window.fetch.bind(window)
    this.interceptors = {
      request: new InterceptorManager<IcsChromelyClient>(),
      response: new InterceptorManager<IMedxResponse<any>>()
    }
    this.interceptors.response.use(response => {
      // console.log(response)
      if (response.code === 200) {
        return Promise.resolve(response.data)
      } else {
        // this.errorFn?.(response)
        return Promise.reject(response)
      }
    })
  }
  // public errorFn(response: IMedxResponse<IMedxResponse<any>>) {}
  public async command(opts: { url: string; data?: any }) {
    if (this.isChromely) {
      if (!(window as any).IMedxAsync) {
        await (window as any)['CefSharp'].BindObjectAsync('IMedxAsync')
      }
      let params: Array<string> = []
      for (let key in opts.data) {
        params.push(key + '=' + opts.data[key])
      }
      await IMedxAsync.command(`${opts.url}${params.length > 0 ? `?${params.join('&')}` : ''}`)
    }
  }

  public async function(opts: {
    url: string
    method?: 'POST' | 'GET'
    data?: any
    headers?: { [key: string]: string }
  }): Promise<any> {
    let chain: PromiseArr<any>[] = [
      {
        resolved: (config: IcsChromelyClient) => {
          if (!this.isChromely) {
            return Promise.reject({
              code: 500,
              message: '浏览器下暂时不支持，正在适配中...',
              data: null
            })
          }
          let options: any = { ...config, ...opts }
          if (options.headers) {
            options.headers['Content-Type'] = options.headers['Content-Type'] || 'application/json'
          } else {
            options.headers = { 'Content-Type': 'application/json' }
          }
          if (opts?.method?.toUpperCase() === 'GET' || opts?.method?.toUpperCase() === 'HEAD') {
            let params = []
            for (let key in opts.data) {
              params.push(key + '=' + opts.data[key])
            }
            opts.url = opts.url + (params.length > 0 ? `?${params.join('&')}` : '')
          } else if (options.headers['Content-Type'] === 'application/json') {
            options.body = JSON.stringify(opts.data)
          } else {
            options.body = opts.data
          }

          let res = config
            .fetch(`${config._baseAjaxUrl}${opts.url.replace(/^\/+/, '')}`, options)
            .then(
              async (res: {
                ok: any
                text: () => string | PromiseLike<string>
                blob: () => string | PromiseLike<string>
                headers: Headers
              }) => {
                if (res.ok) {
                  if (res.headers.get('Content-Type') === 'application/json') {
                    const data = JSON.parse(await res.text())
                    data.config = config
                    data.options = opts
                    return data
                  } else return { code: 200, message: 'ok', data: await res.blob() }
                } else {
                  let error = null
                  const body = await res.text()
                  try {
                    error = JSON.parse(body)
                  } catch {
                    error = {
                      message: body
                    }
                  }
                  error.config = config
                  error.options = opts
                  return Promise.reject(error)
                }
              }
            )
          return res
        },
        rejected: undefined
      }
    ]
    // 拦截器加入执行链
    this.interceptors.request.interceptors.forEach(interceptor => {
      if (interceptor !== null) {
        chain.unshift(interceptor)
      }
    })

    this.interceptors.response.interceptors.forEach(interceptor => {
      if (interceptor !== null) {
        chain.push(interceptor)
      }
    })
    let promise = Promise.resolve({ ...this })

    while (chain.length) {
      const { resolved, rejected } = chain.shift()!
      promise = promise.then(resolved as any, rejected)
    }
    return promise
  }
}

const icsChromelyRequest = new IcsChromelyClient()

export default icsChromelyRequest
